import { ObjectModel } from 'app/models/ObjectModel';
import { Component, inject, Input, OnInit } from '@angular/core';
import { ConverterService } from "../../../../../services/converter.service";
import { UsersService } from 'app/services/users.service';
import { AccessRights } from "../../../../../services/users.service";

@Component({
  selector: 'object-fuel-part',
  templateUrl: './object-fuel-part.component.html',
  styleUrls: ['./object-fuel-part.component.css'],
  standalone: false
})
export class ObjectFuelPartComponent implements OnInit {

  @Input()
  public Object: ObjectModel;
  public canEditTrackers: boolean = false;

  private usersService = inject(UsersService);

  constructor(private converterService: ConverterService) { }

  ngOnInit() {
    this.canEditTrackers = this.usersService.getCurrentUser().CanDo(AccessRights.EDIT_TRACKERS);
  }


  get minParkTime() { return this.Object.MinParkTime / 1000; }
  set minParkTime(value: number) { this.Object.MinParkTime = value * 1000; }
  get timeout() { return this.Object.Timeout / 1000; }
  set timeout(value: number) { this.Object.Timeout = value * 1000; }
  get minIdleTime() { return this.Object.MinIdleTime / 1000; }
  set minIdleTime(value: number) { this.Object.MinIdleTime = value * 1000; }

  public convertMaxDailyEngineTime(value: number) {
    this.Object.MaxDailyEngineTime = value * 3600000;
  }
  public convertMinMovingSpeed(value: number) {
    this.Object.MinMovingSpeed = this.converterService.ParseSpeed(value);
  }
  public convertMaxDailyMileage(value: number) {
    this.Object.MaxDailyMileage = this.converterService.ParseKMeters(value);
  }
  public convertAllowedSpeed(value: number) {
    this.Object.MaxSpeed = this.converterService.ParseSpeed(value);
  }
  public convertParkingRadius(value: number) {
    this.Object.ParkRadius = this.converterService.ParseMeters(value);
  }

  public onIsParkingDetectedChange(event: Event) {
    const val = (event.target as HTMLInputElement).checked;

    if (val)
      this.Object.SetFlag("USE_ENGINE_TO_DETECT_PARKINGS");
    else
      this.Object.ResetFlag("USE_ENGINE_TO_DETECT_PARKINGS");
  }

  public onTypeChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;

    if (value != "MILEAGE_BY_ODO")
      this.Object.ResetFlag("MILEAGE_BY_ODO");
    else
      this.Object.SetFlag("MILEAGE_BY_ODO");
  }
}
